export enum OrderStatus {
    New = "New",
    Open = "Open",
    Released = "Released",
    Shipped = "Shipped",
    Partial = "Partial",
    Post = "Post",
    Closed = "Closed",
    Canceled = "Canceled",
}
